import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import type { APIResponse, FirmLeadSource, MappingTarget } from "@/lib/types";

export const baseFastApiLeadSourcesRoute = "lead-sources/v2";

export function getFirmLeadSourcesV2() {
  return authenticatedFastApiAxiosInstance
    .get<APIResponse<FirmLeadSource[]>>(baseFastApiLeadSourcesRoute)
    .then((res) => res.data);
}

export function getFirmLeadSourceMappingTargetsV2() {
  return authenticatedFastApiAxiosInstance
    .get<
      APIResponse<MappingTarget[]> | MappingTarget[]
    >(`${baseFastApiLeadSourcesRoute}/mapping-targets`)
    .then(
      (res): APIResponse<MappingTarget[]> =>
        Array.isArray(res.data)
          ? { data: res.data, meta: { userMsg: "" } }
          : res.data,
    );
}

export function createFirmLeadSourceV2(
  data: Pick<FirmLeadSource, "label" | "statusId"> &
    Partial<Pick<FirmLeadSource, "description">> & {
      mappings?: Array<{ key: string; targetId: string }>;
    },
) {
  return authenticatedFastApiAxiosInstance
    .post<APIResponse<FirmLeadSource>>(baseFastApiLeadSourcesRoute, data)
    .then((res) => res.data);
}

export function updateFirmLeadSourceV2(
  data: Pick<FirmLeadSource, "id" | "dateModified"> & Partial<FirmLeadSource>,
) {
  return authenticatedFastApiAxiosInstance
    .patch<APIResponse<FirmLeadSource>>(baseFastApiLeadSourcesRoute, data)
    .then((res) => res.data);
}

export function deleteFirmLeadSourceV2(data: { id: string }) {
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<FirmLeadSource>
    >(`${baseFastApiLeadSourcesRoute}/${data.id}`)
    .then((res) => res.data);
}
